export const INIT = 'SUBJECTS_CARDS/INIT';

export const GET_DATA_START = 'SUBJECTS_CARDS/GET_DATA_START';
export const GET_DATA_NEXT_PAGE_START = 'SUBJECTS_CARDS/GET_DATA_NEXT_PAGE_START';

export const COLUMNS_SAVE_USER_SETUP_START = 'SUBJECTS_CARDS/COLUMNS_SAVE_USER_SETUP_START';
export const COLUMNS_GET_CONFIG_START = 'SUBJECTS_CARDS/COLUMNS_GET_CONFIG_START';

export const RECORD_GET_DETAILS_START = 'SUBJECTS_CARDS/RECORD_GET_DETAILS_START';

export const REFRESH_DATA_START = 'SUBJECTS_CARDS/REFRESH_DATA_START';
export const SYNC_DATA_WITH_CACHE_START = 'SUBJECTS_CARDS/SYNC_DATA_WITH_CACHE_START';

export const CHANGE_WKD_FILTER = 'SUBJECTS_CARDS/CHANGE_WKD_FILTER';